<template>
    <Modal
        title="合同预览"
        v-model="visible"
        :mask-closable="false"
        width="900"
        footer-hide
        class-name="contract-preview-modal"
        @on-visible-change="onVisibleChange"
    >
        <div class="preview-body">
            <Spin fix v-if="loading"></Spin>
            <div v-else-if="imgList.length" class="preview-scroll">
                <div v-for="(item, index) in imgList" :key="index" class="preview-page">
                    <img :src="item + cacheBust" alt="合同预览" />
                </div>
            </div>
            <div v-else class="preview-empty">暂无可预览内容</div>
        </div>
    </Modal>
</template>

<script>
import { contractDetails } from '@/api/interFace'

export default {
    name: 'ContractPreview',
    data() {
        return {
            visible: false,
            loading: false,
            imgList: [],
            cacheBust: ''
        }
    },
    methods: {
        /** 通过合同 ID 打开预览 */
        openByContractId(contractId) {
            if (!contractId) {
                this.$Message.warning('暂无合同信息')
                return
            }
            this.visible = true
            this.loading = true
            this.imgList = []
            this.cacheBust = '?v=' + Date.now()
            contractDetails({ id: contractId, pcStatus: 1 }).then(res => {
                const data = res.data || {}
                this.imgList = data.contract_imgs || []
                if (!this.imgList.length && data.contract_path) {
                    this.imgList = [data.contract_path]
                }
            }).catch(err => {
                this.$Message.error((err && err.msg) || '获取合同预览失败')
                this.visible = false
            }).finally(() => {
                this.loading = false
            })
        },
        /** 直接传入合同数据打开预览 */
        openByData(data) {
            if (!data) {
                this.$Message.warning('暂无合同信息')
                return
            }
            this.visible = true
            this.loading = false
            this.cacheBust = '?v=' + Date.now()
            this.imgList = data.contract_imgs || []
            if (!this.imgList.length && data.contract_path) {
                this.imgList = [data.contract_path]
            }
        },
        onVisibleChange(val) {
            if (!val) {
                this.imgList = []
                this.loading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.preview-body {
    position: relative;
    min-height: 400px;
    max-height: 70vh;
}

.preview-scroll {
    max-height: 70vh;
    overflow-y: auto;
    padding: 4px 0;
    background: #f2f4f9;
}

.preview-page {
    width: 100%;
    max-width: 820px;
    margin: 0 auto 12px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

    img {
        display: block;
        width: 100%;
        height: auto;
    }
}

.preview-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    color: #8A93A6;
    font-size: 14px;
}
</style>

<style lang="scss">
.contract-preview-modal {
    .ivu-modal-body {
        padding: 16px 24px 24px;
    }
}
</style>
